/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { MLETemperatureChartContext, MLETemperatureChartData } from "./d";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { getMLETemperatureDataset } from "./getMLETemperatureDataset";
import type { ConvertableUnit } from "@/libs/units";

const buildMLETemperatureChartContext = (
  calcs: ScenarioCalculations,
  targetTempUnit: ConvertableUnit
): MLETemperatureChartContext | undefined => {
  const destructuredScenario = calcs.destructuredScenario;
  // @ts-ignore
  const equipment = destructuredScenario.equipment?.value;
  if (!equipment) return undefined;
  const context: MLETemperatureChartContext = {
    targetTempUnit,
    maxTemp: equipment.r_mle?.max_temperature_fahrenheit ?? 500,
    minTemp: 0,
    motorCurrentA: calcs.motorCalculations.motorCurrentA.value,
    downholeTempAtCableEndF:
      calcs.motorLeadExtensionCalculations.mleCableData.value
        .downholeTempAtCableEndF,
    ampFactor: equipment.r_mle?.amp_factor ?? 0,
    mleLabel:
      calcs.motorLeadExtensionCalculations.mleCableData.value.cableHeader
  };

  return context;
};

export const useMLETemperatureChartData = (
  scenarioCalculations: ScenarioCalculations,
  targetTempUnit: ConvertableUnit
): MLETemperatureChartData | undefined => {
  const context = buildMLETemperatureChartContext(
    scenarioCalculations,
    targetTempUnit
  );

  if (!context) {
    return undefined;
  } else {
    const mleTemperatureDataSet = getMLETemperatureDataset(context);
    return {
      targetTempUnit,
      mleTemperatureDataSet
    };
  }
};
